/* Royal Arms USA - load full-resolution images for "Just the Tip" cards before the hover zoom.
   The theme serves card images sized for the card; ra-hover.css zooms ~3x, so we raise `sizes`
   on hover (and on touch/focus) so the browser fetches a large srcset candidate. AI theme only. */
(function () {
  var SEL = '.card__inner[style*="--ratio-percent: 48.8"] .card__media .media img';
  function boost(scope) {
    scope.querySelectorAll(SEL).forEach(function (img) {
      if (img.dataset.raBoosted) return;
      img.dataset.raBoosted = '1';
      var w = Math.ceil((img.getBoundingClientRect().width || 300) * 3.1);
      img.setAttribute('sizes', w + 'px');
      img.loading = 'eager';
    });
  }
  function onEnter(e) {
    var card = e.target && e.target.closest && e.target.closest('.card-wrapper');
    if (card) boost(card);
  }
  document.addEventListener('mouseover', onEnter, { passive: true });
  document.addEventListener('focusin', onEnter);
})();
